import * as React from 'react';
import { Button, ButtonToolbar } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Radium from 'radium';

@Radium
export default class MenuButtons extends React.Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    style: PropTypes.object
  };

  static defaultProps = {
    style: {}
  };

  render() {
    return (
      <ButtonToolbar style={this.props.style}>
        <Button bsStyle="success" data-tid="menu-link-order" href="/objednavka/workshopy">
          <i className="fa fa-shopping-cart">&nbsp;</i>
          Objednat workshop
        </Button>
        <Button bsStyle="success" data-tid="menu-link-order" href="https://1url.cz/@karetnihra" target="_blank">
          <i className="fa fa-shopping-cart">&nbsp;</i>
          Karetní hra
        </Button>
        <Button bsStyle="facebook" href="https://www.facebook.com/studentizakum" target="_blank">
          <i className="fa fa-facebook-official"></i>
        </Button>
        <Button bsStyle="instagram" href="https://www.instagram.com/studentizakum/" target="_blank">
          <i className="fa fa-instagram"></i>
        </Button>
      </ButtonToolbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/components/social_buttons.jsx